var _circle, _circle2, _circle3, _circle4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 277,
    viewBox: "0 0 298 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 279.5,
    cy: 233.5,
    r: 18.5,
    fill: "#DBDBDB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 173.5,
    cy: 267.5,
    r: 9.5,
    fill: "#DBDBDB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 254.5,
    cy: 170.5,
    r: 7.5,
    fill: "#DBDBDB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 191,
    cy: 155,
    r: 7,
    fill: "#DBDBDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.012 64.0019C161.317 60.194 154.363 57.8862 147.149 57.0784C139.935 56.2707 132.923 56.7611 126.112 58.5497C119.302 60.3383 112.954 63.3672 107.067 67.6367C101.181 71.9062 96.3328 77.2142 92.5237 83.5607L70.5352 120.947L29.3284 147.603L81.0966 176.681C80.5195 177.835 80.0578 179.047 79.7115 180.316C79.3652 181.585 79.1921 182.855 79.1921 184.124C79.1921 188.74 80.808 192.663 84.04 195.894C87.2719 199.125 91.1963 200.74 95.8133 200.74C98.8144 200.74 101.556 200.019 104.037 198.577C106.519 197.134 108.452 195.259 109.838 192.952L163.164 222.896L166.107 174.777L188.096 137.564C191.905 131.102 194.242 124.323 195.108 117.226C195.974 110.129 195.483 103.264 193.636 96.6288C191.789 89.9937 188.702 83.8204 184.373 78.1085C180.045 72.3966 174.591 67.6944 168.012 64.0019Z",
    fill: "#C4C6CB"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 225.828,
    cy: 167.172,
    r: 36.1716,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 18.5746,
    cy: 233.649,
    r: 18.5746,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 176.948,
    cy: 43.9925,
    r: 14.6642,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 52.791,
    cy: 13.6866,
    r: 13.6866,
    fill: "#F7F7F7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBgBell);
export default __webpack_public_path__ + "static/media/ico_bg_bell.a753e5ae8f3305bdc23f04c64d7b486a.svg";
export { ForwardRef as ReactComponent };